import * as React from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { NavigationLink } from '../../Links/Links';
import NavigationContent from './NavigationContent';
import MenuBackground from '../../Overlay';
import { onSaleParam, newInParam } from '../../../helpers/helpers';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

const SalesNewIn: React.ComponentType<{
  buildUrlWithCountry: (route: string) => string;
  department: string;
  getColor: (color: string) => string;
  hoverLeftImg: object;
  hoverRightImg: object;
  menuToRender: any;
  navIndex: string;
  sales: boolean;
  setNavIndex: (index?: string) => string;
}> = ({
  sales,
  navIndex,
  menuToRender,
  hoverLeftImg,
  hoverRightImg,
  department,
  getColor,
  buildUrlWithCountry,
  setNavIndex,
}) => {
  const index = sales ? 'sales' : 'newIn';
  const title = sales ? 'sale' : 'new in';

  return (
    <div
      onFocus={() => {}}
      onMouseLeave={() => setNavIndex()}
      onMouseOver={() => setNavIndex(index)}
      style={{ position: 'relative' }}
    >
      <CSSTransitionGroup transitionAppear transitionEnter={false} transitionLeave={false} transitionName="fade-nav">
        <NavigationLink
          key={index}
          color={sales ? '#F25C5E' : getColor(index)}
          cursor="pointer"
          hoverColor={sales ? '#F25C5E' : '#000'}
          href={buildUrlWithCountry(`${menuToRender.url}/?${sales ? onSaleParam : newInParam}`)}
          padding="0 15px"
          underline={navIndex === index}
        >
          <span>{title}</span>
        </NavigationLink>
      </CSSTransitionGroup>
      {navIndex === index && (
        <>
          <NavigationContent
            department={department}
            hoverLeftImg={hoverLeftImg}
            hoverRightImg={hoverRightImg}
            newIn={index === 'newIn'}
            sales={index === 'sales'}
            values={menuToRender}
          />
          <MenuBackground pointerEvents="none" />
        </>
      )}
    </div>
  );
};

export default withCountryCode(SalesNewIn);
